import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ children, minRole = "editor" }) {
  const { user, hasRole } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <p className="font-stats text-xs text-neutral-600 uppercase tracking-widest animate-pulse">
          Vérification de la session…
        </p>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  if (!hasRole(minRole)) {
    return (
      <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center gap-4 px-6">
        <p className="font-display font-black text-4xl text-white text-center">
          ACCÈS REFUSÉ
        </p>
        <p className="text-neutral-500 text-sm text-center max-w-md">
          Votre rôle ({user.role}) ne permet pas d'accéder à cette section. Contactez un super_admin.
        </p>
      </div>
    );
  }
  return children;
}
